


export type RegieWorkOptions = 'None' | 'RegieWork';

export const RegieWorkOptions = {
    None: 'None' as RegieWorkOptions,
    RegieWork: 'RegieWork' as RegieWorkOptions
};

